import { ApolloClient, ApolloProvider, NormalizedCacheObject } from '@apollo/client'
import * as React from 'react'
import { FC } from 'react'
import * as ReactDOM from 'react-dom'

import 'antd/dist/antd.css'
import apolloClient from 'clients/apollo'
import { buildCompositeGraphQLProvider } from 'dash/dataProviders/composite'
import DashLayout from 'dash/layout'
import { ErrorBoundary } from 'shared/bugsnag'
import '../dash/custom.scss'

import { AppLoadingView } from '../dash/AppLoadingView'

import { GoogleTagManager } from 'integrations/google-tag-manager'
import { Plausible } from 'integrations/plausible'

const DashboardApp: FC = () => {
  // State

  const [client, setClient] = React.useState<ApolloClient<NormalizedCacheObject>>()
  const [dataProvider, setDataProvider] = React.useState<any>()

  // Helpers

  const init = async () => {
    Plausible.init()
    GoogleTagManager.init()

    setClient(apolloClient)

    try {
      const dataProvider = await buildCompositeGraphQLProvider()
      setDataProvider(() => dataProvider) // https://github.com/marmelab/react-admin/issues/3340#issuecomment-530236739
    } catch (e) {
      console.log('error in initDataProvider', e)
    }
  }

  // Effects

  React.useEffect(() => {
    init()
    // ? teardown required
  }, []) // only init once

  if (!dataProvider) return AppLoadingView

  return (
    <ApolloProvider client={client}>
      <DashLayout dataProvider={dataProvider} />
    </ApolloProvider>
  )
}

document.addEventListener('DOMContentLoaded', () => {
  const App = ErrorBoundary ? (
    <ErrorBoundary>
      <DashboardApp />
    </ErrorBoundary>
  ) : (
    <DashboardApp />
  )

  ReactDOM.render(App, document.body.appendChild(document.createElement('div')))
})
